const state = () => ({
  currentSession: [],
  flashcards: {},
  flashcardSessionStarted: false,
});

const getters = {
  flashcards: state => state.flashcards,
  flashcardList: state => Object.keys(state.flashcards).map(id => state.flashcards[id]).filter(flashcard => flashcard),
  currentSession: state => state.currentSession,
  flashcardSessionStarted: state => state.flashcardSessionStarted,
};

const mutations = {
  setFlashcardSession(state, ids) {
    state.currentSession = ids;
    state.flashcardSessionStarted = true;
  },
  setFlashcards(state, data) {
    data.records.forEach(card => {
      // when a user quiz, the API doesn't return the flashcard with that category id
      if (data.categoryId) {
        card.categoryIds.push(data.categoryId);
      }

      state.flashcards[card?.id] = card;
    });
  },
};

const actions = {
  createFlashcardSession({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/flashcard_sessions/', params).then(response => {
      if(response.status == 200) {
        commit('setFlashcardSession', response.data.session);
        commit('setFlashcards', { records: response.data.flashcards });
        commit('flashcardStates/setFlashcardStates', response.data.flashcardStates, { root: true });
        return getters.flashcards[getters.currentSession[0]];
      }
    });
  },
  createUserQuizFlashcardSession({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/flashcard_sessions/', params).then(response => {
      if(response.status == 200) {
        commit('setFlashcardSession', response.data.session);
        commit('setFlashcards', { records: response.data.flashcards });
        commit('flashcardStates/setFlashcardStates', response.data.flashcardStates, { root: true });
        return getters.flashcards[response.data.flashcards[0]?.id];
      }
    });
  },
  fetchFlashcards({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].get('/flashcards', { params }).then(response => {
      if (response.data.records) {
        commit('setFlashcards', { records: response.data.records, categoryId: params.categoryId });
        return response.data.records;
      } else {
        commit('setFlashcards', { records: response.data.flashcards, categoryId: params.categoryId });
        return response.data.flashcards;
      }
    });
  },
  fetchQuestionOfTheDay({ commit, rootGetters }) {
    return rootGetters['session/ajax'].get('/question_of_the_day').then(response => {
      commit('setFlashcards', { records: [ response.data.flashcard ], categoryId: response.data.categoryId });
      return response.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
